import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMonth'
})
export class FilterMonthPipe implements PipeTransform {

  transform(id: number): string {
    switch (id) {
      case 1:
        return $localize`:@@statementsJanuary:Enero`;

      case 2:
        return $localize`:@@statementsFebruary:Febrero`;

      case 3:
        return $localize`:@@statementsMarch:Marzo`;

      case 4:
        return $localize`:@@statementsApril:Abril`;

      case 5:
        return $localize`:@@statementsMay:Mayo`;

      case 6:
        return $localize`:@@statementsJune:Junio`;

      case 7:
        return $localize`:@@statementsJuly:Julio`;

      case 8:
        return $localize`:@@statementsAugust:Agosto`;

      case 9:
        return $localize`:@@statementsSeptember:Septiembre`;

      case 10:
        return $localize`:@@statementsOctober:Octubre`;

      case 11:
        return $localize`:@@statementsNovember:Noviembre`;

      case 12:
        return $localize`:@@statementsDecember:Diciembre`;

      default:
        return id.toString();
    }
  }

}
